import { defineStore } from 'pinia'
import { useUserStore } from '@/stores/user-store'
import { timePeriodsWithValues } from '@/constants/time-types'

export const useStatesStore = defineStore('states-store', {
  state: () => ({
    apiKey: null,
    error: {},
    surveyName: null,
    surveyIsAggregate: false,
    surveyIsAggregateV2: false,
    organizationName: null,
    selectedGroup: {},
    teamForSelectedGroup: null,
    organizationGroup: {},
    organizationFeatures: {},
    viewMode: 'default',
    selectedTimePeriod: Object.keys(timePeriodsWithValues)[0], // default to the first time period
    selectedAttributeName: null,
    selectedAttributeSegment: null,
    attributesForResults: []
  }),
  getters: {
    getApiKey: (state) => {
      return state.apiKey
    },
    getOrganizationFullName: () => {
      const userStore = useUserStore()
      return userStore.getUserInfo.organizationFullName
    },
    getOrganizationName: (state) => {
      return state.organizationName
    },
    getSelectedGroup: (state) => {
      return state.selectedGroup
    },
    getSurveyName: (state) => {
      return state.surveyName
    },
    getOrganizationGroup: (state) => {
      return state.organizationGroup
    },
    getViewMode: (state) => {
      return state.viewMode
    },
    getSelectedTimePeriod: (state) => {
      return state.selectedTimePeriod
    },
    getSelectedAttributeName: (state) => {
      return state.selectedAttributeName
    },
    getSelectedAttributeSegment: (state) => {
      return state.selectedAttributeSegment
    },
    getAttributesForResults: (state) => {
      return state.attributesForResults
    }
  },
  actions: {
    setApiKey(apiKey) {
      this.apiKey = apiKey
    },
    setOrganizationName(organizationName) {
      this.organizationName = organizationName
    },
    setSurveyName(surveyName) {
      this.surveyName = surveyName
    },
    setSurveyIsAggregate(surveyIsAggregate) {
      this.surveyIsAggregate = surveyIsAggregate
    },
    setSurveyIsAggregateV2(surveyIsAggregateV2) {
      this.surveyIsAggregateV2 = surveyIsAggregateV2
    },
    setSelectedGroup(selectedGroup) {
      this.selectedGroup = selectedGroup
    },
    setTeamForSelectedGroup(teamForSelectedGroup) {
      this.teamForSelectedGroup = teamForSelectedGroup
    },
    setOrganizationGroup(organizationGroup) {
      this.organizationGroup = organizationGroup
    },
    setOrganizationFeatures(organizationFeatures) {
      this.organizationFeatures = organizationFeatures
    },
    setViewMode(viewMode) {
      this.viewMode = viewMode
    },
    setSelectedTimePeriodAction(selectedTimePeriod) {
      this.selectedTimePeriod = selectedTimePeriod
    },
    setSelectedAttributeSegment(selectedAttributeSegment) {
      this.selectedAttributeSegment = selectedAttributeSegment
    },
    setAttributesForResults(attributes) {
      this.attributesForResults = attributes
    }
  }
})
